import React, { useState } from 'react';
import './ListViewInfo.css';
import { SideMenuBar } from '../../SideMenu';
import { NewHeader } from '../../NewHeader';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API_URL } from '../../Config';

const ListViewInfo = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const taskDetails = location.state?.taskDetails || null;

  const [formData, setFormData] = useState({
    status: taskDetails?.status || '',
  });

  if (!taskDetails) {
    return (
      <div className="task_info_app">
        <SideMenuBar />
        <main className="content">
          <NewHeader />
          <div className="task_info_container">
            <div className="task_info_empty">
              <span className="page_kicker">TASK WORKSPACE</span>
              <h1>Task not found</h1>
              <p>No task details were provided for this page.</p>
              <button type="button" onClick={() => navigate('/ListView')}>
                Back to tasks
              </button>
            </div>
          </div>
        </main>
      </div>
    );
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const formatToLocalTime = (utcTimestamp) => {
    if (!utcTimestamp || isNaN(new Date(utcTimestamp).getTime())) {
      return 'Not available';
    }

    const options = {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
    };

    return new Date(utcTimestamp).toLocaleString(undefined, options);
  };

  const updateTaskk = async () => {
    try {
      if (taskDetails.status !== formData.status) {
        const updatedFormData = { ...formData };

        if (formData.status === 'In-Process') {
          updatedFormData.startTime = taskDetails.startTime || new Date().toISOString();
        } else if (formData.status === 'Completed') {
          updatedFormData.startTime = taskDetails.startTime || new Date().toISOString();
          updatedFormData.endTime = new Date().toISOString();
        }

        const response = await axios.put(
          API_URL + `/taskss/${taskDetails.uuId}`,
          updatedFormData
        );

        if (response.status === 200) {
          console.log('Task updated successfully');
          navigate('/ListView');
        } else {
          console.error('Error updating task');
        }
      } else {
        const response = await axios.put(
          API_URL + `/taskss/${taskDetails.uuId}`,
          formData
        );

        if (response.status === 200) {
          console.log('Task updated successfully');
          navigate('/ListView');
        } else {
          console.error('Error updating task');
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  const calculateTotalTime = () => {
    if (taskDetails.startTime) {
      const startTime = new Date(taskDetails.startTime);
      let endTime;

      if (taskDetails.endTime && !isNaN(new Date(taskDetails.endTime).getTime())) {
        endTime = new Date(taskDetails.endTime);
      } else {
        endTime = new Date();
      }

      const timeDifference = endTime - startTime;
      const days = Math.floor(timeDifference / (24 * 60 * 60 * 1000));
      const hours = Math.floor(
        (timeDifference % (24 * 60 * 60 * 1000)) / (60 * 60 * 1000)
      );
      const minutes = Math.floor(
        (timeDifference % (60 * 60 * 1000)) / (60 * 1000)
      );
      const seconds = Math.floor((timeDifference % (60 * 1000)) / 1000);

      return `${days}d - ${hours}hrs - ${minutes}min - ${seconds}secs`;
    }

    return '00:00:00';
  };

  const statusClass = (status) => {
    const key = (status || '').toLowerCase().replace(/\s+/g, '-');
    if (key === 'completed') return 'status_completed';
    if (key === 'in-process') return 'status_process';
    return 'status_pending';
  };

  const priorityClass = (priority) => {
    const key = (priority || '').toLowerCase();
    if (key === 'high') return 'priority_high';
    if (key === 'medium') return 'priority_medium';
    return 'priority_low';
  };

  return (
    <div className="task_info_app">
      <SideMenuBar />

      <main className="content">
        <NewHeader />

        <div className="task_info_container">
          <section className="task_info_heading">
            <div>
              <span className="page_kicker">WORK MANAGEMENT / TASK</span>
              <h1>Task details</h1>
              <p>Review assignment information, client context and task progress.</p>
            </div>

            <button
              type="button"
              className="back_to_tasks"
              onClick={() => navigate('/ListView')}
            >
              ← Back to tasks
            </button>
          </section>

          <section className="task_info_hero">
            <div className="task_identity">
              <span className="task_avatar">
                {(taskDetails.assignee || '?').charAt(0).toUpperCase()}
              </span>
              <div>
                <span className="page_kicker">ASSIGNEE</span>
                <h2>{taskDetails.assignee || 'Unassigned'}</h2>
                <p>{taskDetails.category || 'General task'}</p>
              </div>
            </div>

            <div className="hero_status">
              <span className="hero_label">CURRENT STATUS</span>
              <b className={`status_chip ${statusClass(taskDetails.status)}`}>
                {taskDetails.status || 'Not available'}
              </b>
            </div>
          </section>

          <div className="task_info_grid">
            <section className="info_panel">
              <div className="panel_header">
                <div>
                  <span className="panel_number">01</span>
                  <div>
                    <h3>Task information</h3>
                    <p>Core task details and workflow state.</p>
                  </div>
                </div>
              </div>

              <div className="field_grid">
                <div className="info_field full">
                  <span>Task</span>
                  <strong>{taskDetails.taskDetails || 'Not available'}</strong>
                </div>

                <div className="info_field">
                  <span>Priority</span>
                  <b className={`status_chip ${priorityClass(taskDetails.priority)}`}>
                    {taskDetails.priority || 'Not available'}
                  </b>
                </div>

                <div className="info_field">
                  <span>Category</span>
                  <strong>{taskDetails.category || 'Not available'}</strong>
                </div>

                <div className="info_field">
                  <span>Sub category</span>
                  <strong>{taskDetails.subCategory || 'Not available'}</strong>
                </div>

                <div className="info_field">
                  <span>Deadline</span>
                  <strong>{taskDetails.deadline || 'Not available'}</strong>
                </div>

                <div className="info_field">
                  <span>Status</span>
                  <select
                    className="status_select"
                    name="status"
                    value={formData.status}
                    onChange={handleInputChange}
                    disabled={formData.status === 'Completed'}
                  >
                    <option value="" disabled>Select</option>
                    <option value="Pending">Pending</option>
                    <option value="In-Process">In-Process</option>
                    <option value="Completed">Completed</option>
                  </select>
                </div>
              </div>

              <a href="/" onClick={(e) => e.preventDefault()} className="location_link">
                <span>⌖</span>
                Click here to view current location
              </a>
            </section>

            <section className="info_panel">
              <div className="panel_header">
                <div>
                  <span className="panel_number">02</span>
                  <div>
                    <h3>Client information</h3>
                    <p>Contact and site information for this task.</p>
                  </div>
                </div>
              </div>

              <div className="field_grid">
                <div className="info_field">
                  <span>Name</span>
                  <strong>{taskDetails.clientName || 'Not available'}</strong>
                </div>

                <div className="info_field">
                  <span>Site name</span>
                  <strong>{taskDetails.siteName || 'Not available'}</strong>
                </div>

                <div className="info_field">
                  <span>Phone</span>
                  <strong>{taskDetails.siteMobile || 'Not available'}</strong>
                </div>

                <div className="info_field">
                  <span>Email</span>
                  <strong>{taskDetails.siteEmail || 'Not available'}</strong>
                </div>

                <div className="info_field full">
                  <span>Address</span>
                  <strong>{taskDetails.siteAddress || 'Not available'}</strong>
                </div>
              </div>

              <a href="/GalleryMedia" className="gallery_link">
                <span>▧</span>
                View project gallery
                <b>→</b>
              </a>
            </section>
          </div>

          <section className="time_panel">
            <div className="time_panel_heading">
              <div>
                <span className="page_kicker">WORK LOG</span>
                <h3>Task timing</h3>
              </div>
              <span className="time_live">
                <i /> Live calculation
              </span>
            </div>

            <div className="time_grid">
              <div className="time_card">
                <span>Start time</span>
                <strong>{formatToLocalTime(taskDetails.startTime)}</strong>
              </div>
              <div className="time_card">
                <span>End time</span>
                <strong>{formatToLocalTime(taskDetails.endTime)}</strong>
              </div>
              <div className="time_card total">
                <span>Total time</span>
                <strong>{calculateTotalTime()}</strong>
              </div>
            </div>
          </section>

          <div className="task_update_bar">
            <div>
              <span className="page_kicker">WORKFLOW ACTION</span>
              <strong>Save task changes</strong>
            </div>
            <button type="button" className="update_btn_input_TaskViewInfo" onClick={updateTaskk}>
              Update task
              <span>→</span>
            </button>
          </div>
        </div>
      </main>
    </div>
  );
};

export default ListViewInfo;
